import type { CmChecklist } from '@luxuryescapes/contract-svc-offer';

export const SOURCE_LABELS: Record<CmChecklist.SourceId, string> = {
  account: 'vendor account',
  contract_template: 'contract template',
  manual_overrides: 'manual overrides',
  offer: 'offer',
  opportunity: 'opportunity',
  opportunity_related: 'deal options & inclusions',
  parent_account: 'vendor parent account',
  property: 'property',
  salesforce_surcharges: 'salesforce surcharge',
};

const ERROR_CODE_LABELS: Record<CmChecklist.SourceErrorCode, string> = {
  missing_reference: 'missing reference',
  not_found: 'not found',
  timeout: 'timed out',
  upstream_error: 'upstream error',
  upstream_unavailable: 'unavailable',
};

export function getSourceErrorMessage(source: CmChecklist.SourceId, errorCode: CmChecklist.SourceErrorCode | null) {
  const suffix = errorCode ? ` (${ERROR_CODE_LABELS[errorCode]})` : '';

  return `Could not load ${SOURCE_LABELS[source]} evidence${suffix}`;
}

export function getFailedSourceMessages(sources: Array<CmChecklist.SourceStatus>) {
  return sources
    .filter((source) => source.status === 'error')
    .map((source) => getSourceErrorMessage(source.id, source.error_code));
}
